import { ReactNode } from 'react';
import { SxStyleProp } from 'theme-ui';
import SimpleBar from 'simplebar-react';
import 'simplebar/src/simplebar.css';

const styles: SxStyleProp = {
  height: '100%',
  width: '100%',
  overflow: 'hidden',

  '& .simplebar-scrollbar:before': {
    background: (theme: any) => theme.colors.grey,
    width: 4,
    borderRadius: 4,
    left: '4px',
    right: 0
  },

  '& .simplebar-offset': {
    maxWidth: '100%'
  },

  '& .simplebar-scrollbar.simplebar-visible:before': {
    opacity: 1
  }
};

export default ({ children }: { children: ReactNode }) => {
  return (
    <div sx={styles}>
      <SimpleBar autoHide={true} style={{ maxHeight: '100%', maxWidth: '100%' }}>
        {children}
      </SimpleBar>
    </div>
  );
};
